import { createRoutine } from 'redux-saga-routines'
import { IDeviceState } from './device.interface'
import { DEVICE_STATUS } from './constants'

const initialDeviceState: IDeviceState = {
  devices: [],
  submitting:false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  },
  error: false,
  loading: false,
  success: false
}

export const addDevice = createRoutine('ADD_DEVICE')
export const getDevice = createRoutine('GET_DEVICE')
export const editDevice = createRoutine('EDIT_DEVICE')
export const getAllDevices = createRoutine('GET_ALL_DEVICES')
export const deleteDevice = createRoutine('DELETE_DEVICE')
export const clearSelectedDevice = createRoutine('CLEAR_SELECTED_DEVICE')
export const clearDevices = createRoutine('CLEAR_DEVICES')
export const updateAfterUnAssign = createRoutine('UPDATE_AFTER_UNASSIGN')

export default function device(state = initialDeviceState, action: any) {
  switch (action.type) {
    case addDevice.TRIGGER:
      return { ...state, loading: true, submitting:true, error: false, success: false }
    case addDevice.SUCCESS:
      return {
        ...state,
        submitting: false,
        success: true,
        error: false,
      }
    case addDevice.FAILURE:
      return {
        ...state,
        submitting:false,
        success: false,
        error: true
      }
    case getDevice.TRIGGER:
      return { ...state, loading: true, selectedDevice: null, error: false, success: false }
    case getDevice.SUCCESS:
      return {
        ...state,
        loading:false,
        success: true,
        selectedDevice: action.payload,
        error: false
      }
    case getDevice.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
    case editDevice.TRIGGER:
      return { ...state, submitting: true, error: false, success: false }
    case editDevice.SUCCESS:
      return {
        ...state,
        submitting : false,
        success: true,
        selectedDevice: action.payload,
        error: false
      }
    case editDevice.FAILURE:
      return {
        ...state,
        submitting : false,
        success: false,
        error: true
      }
    case getAllDevices.TRIGGER:
      return { ...state, loading: true, devices:[], error: false, success: false }
    case getAllDevices.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        devices: action.payload.devices,
        meta: action.payload.meta,
        error: false
      }
    case getAllDevices.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true
      }
    case deleteDevice.TRIGGER:
      return { ...state, submitting : true, error: false, success: false }
    case deleteDevice.SUCCESS:
      return {
        ...state,
        submitting:false,
        success: true,
        error: false
      }
    case deleteDevice.FAILURE:
      return {
        ...state,
        submitting:false,
        success: true,
        error: true
      }
    case clearSelectedDevice.TRIGGER:
      return {
        ...state,
        selectedDevice: null
      }
    case clearDevices.TRIGGER:
      return {
        ...state,
        devices: []
      }
    case updateAfterUnAssign.TRIGGER:
      return {
        ...state,
        selectedDevice : {
          ...state.selectedDevice,
          patient: null,
          assignedOn: null,
          status: DEVICE_STATUS.FREE
        }
      }

    default:
      return state
  }
}
